/*
  Commonly used regular expressions for re-use
*/

export const RegularExpressions = {
  NUMERIC: /[0-9]/,
  ALPHA_NUMERIC: /[0-9a-z]/i,
  ALPHA_IGNORECASE: /[a-z]/i,
  ALPHA_UPPERCASE: /[A-Z]/,
  ALPHA_LOWERCASE: /[a-z]/,
  NON_NUMERIC: /[^0-9]/,
  EMAIL_SIMPLE: /^(.+)@(.+)\.([0-9a-z]{2,})$/i,
  PHONE: /^[0-9\-\ ]*$/,
  WHITESPACE: /\s/,
  DATE_OF_BIRTH: /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d$/,
};
